module.exports = __webpack_public_path__ + "static/media/pdfIcon.952015eb.svg";